import { forwardRef, type PropsWithChildren } from 'react';
import styled from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';
import { MAX_COLUMN_WIDTH, MIN_COLUMN_WIDTH } from '../../constants';
import { tableMixin } from './table-mixin';

export const Table = forwardRef<
  HTMLDivElement,
  PropsWithChildren<{ component: string }>
>(({ children, component }, ref) => {
  return (
    <Container
      ref={ref}
      className={createReadableClass(
        {
          component,
          element: 'container'
        },
        ['es-layout-component']
      )}
    >
      <Inner
        className={createReadableClass({
          component,
          element: 'inner'
        })}
      >
        {children}
      </Inner>
    </Container>
  );
});

const Inner = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: center;
  grid-auto-columns: minmax(${MIN_COLUMN_WIDTH}px, ${MAX_COLUMN_WIDTH}px);
  ${tableMixin}
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
`;
